import {useRedirectToFirstCard} from 'helpers';

export function Home() {
  useRedirectToFirstCard();
  return null;
}
